import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';

export const disableRecurring = createAsyncThunk<{status: boolean, message: string}, void>(
    'auth/disableRecurring',

    async() => {

        const response = await createHttpRequest({
            method: 'POST',
            path: ApiUrls.USER_DISABLE_RECURRING,
            data: {},
            errorMessage: t`При отключении периодического платежа произошла ошибка!`,
        });

        return response.data;
    },
);
